import { render, staticRenderFns } from "./customDashboardTable.vue?vue&type=template&id=b0ea58b0&scoped=true"
import script from "./customDashboardTable.vue?vue&type=script&lang=js"
export * from "./customDashboardTable.vue?vue&type=script&lang=js"
import style0 from "./customDashboardTable.vue?vue&type=style&index=0&id=b0ea58b0&prod&lang=scss&scoped=true"
import style1 from "./customDashboardTable.vue?vue&type=style&index=1&id=b0ea58b0&prod&lang=scss&scoped=true"
import style2 from "./customDashboardTable.vue?vue&type=style&index=2&id=b0ea58b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ea58b0",
  null
  
)

export default component.exports